import gql from 'graphql-tag'

export const CREATE_CITATION = gql`
  mutation CreateCitation(
    $projectId: String!
    $pubType: String
    $sourceType: String
    $annotation: String
    $contributors: [ContributorInput!]
    $data: JSON!
  ) {
    createCitation(
      projectId: $projectId
      pubType: $pubType
      sourceType: $sourceType
      annotation: $annotation
      contributors: $contributors
      data: $data
    ) {
      citationId
      id: citationId
      projectId
      data
      annotation
      contributors {
        data
        first
        function
        last
      }
    }
  }
`

export const CREATE_BULK_CITATIONS = gql`
  mutation CreateBulkCitations($projectId: String!, $dataArray: [CreateCitationInput!]!) {
    createBulkCitations(projectId: $projectId, dataArray: $dataArray) {
      citationId
    }
  }
`

export const UPDATE_CITATION = gql`
  mutation UpdateCitation(
    $projectId: String!
    $citationId: String!
    $pubType: String
    $sourceType: String
    $annotation: String
    $contributors: [ContributorInput!]
    $data: JSON!
  ) {
    updateCitation(
      projectId: $projectId
      citationId: $citationId
      pubType: $pubType
      sourceType: $sourceType
      annotation: $annotation
      contributors: $contributors
      data: $data
    ) {
      citationId
      id: citationId
      projectId
      data
      annotation
      contributors {
        first
        middle
        last
        function
        data
      }
      date: createdAt
    }
  }
`

export const MOVE_CITATIONS = gql`
  mutation MoveCitations($projectId: String!, $citationIds: [String]!) {
    moveCitations(projectId: $projectId, citationIds: $citationIds) {
      movedCitationsCount
    }
  }
`

export const DELETE_CITATION = gql`
  mutation DeleteCitation($projectId: String!, $citationId: String!) {
    deleteCitation(projectId: $projectId, citationId: $citationId)
  }
`

export const GET_CITATION = gql`
  query GetCitation($projectId: String!, $citationId: String!) {
    citation(projectId: $projectId, citationId: $citationId) {
      id: citationId
      citationId
      projectId
      data
      annotation
      contributors {
        first
        middle
        last
        function
        data
      }
    }
  }
`

export const CREATE_CITATION_NOTE = gql`
  mutation CreateCitationNote($projectId: String!, $citationId: String!, $text: String!) {
    createComment(projectId: $projectId, citationId: $citationId, text: $text) {
      id
    }
  }
`

export const CITATION_COUNT = gql`
  query Citationcount($projectId: String!) {
    citationCount(projectId: $projectId) {
      count
    }
  }
`
